import React, { useState } from 'react';
import { AiOutlineCloudUpload } from 'react-icons/ai';
import { useNavigate } from 'react-router-dom';
import { MdDelete } from 'react-icons/md';
import { Families } from '../utils/data';
import { categories } from '../utils/data';
import { client } from '../client';
import Spinner from './Spinner';
import { v4 as uuidv4 } from 'uuid';


const CreateFamily = ({ user }) => {
  const [title, setTitle] = useState('');
  const [loading, setLoading] = useState(false);
  const [fields, setFields] = useState();
  const [wrongImageType, setWrongImageType] = useState(false);
  const [error, setError] = useState(false);
  const [imageAsset, setImageAsset] = useState();
  const [familyName, setFamilyName] = useState();
  const [users, setUsers] = useState([]);


  const navigate = useNavigate();

  const uploadImage = (e) => {
    const selectedFile = e.target.files[0];

    // uploading asset to sanity
    if (selectedFile.type === 'image/png' || selectedFile.type === 'image/svg' || selectedFile.type === 'image/jpeg' || selectedFile.type === 'image/gif' || selectedFile.type === 'image/tiff') {
      setWrongImageType(false);
      setError(false);
      setLoading(true);
      client.assets
        .upload('image', selectedFile, { contentType: selectedFile.type, filename: selectedFile.name })
        .then((document) => {
          setImageAsset(document);
          setLoading(false);
        })
        .catch((error) => {
          console.log('Upload failed:', error.message);
          setLoading(false);
          setError(true);
        });
    } else {
      setLoading(false);
      setWrongImageType(true);
    }
  };


  const savePin = () => {
    setUsers([user]);
    if (familyName && imageAsset?._id && !wrongImageType) {
      const doc = {
        _type: 'family',
        familyName,
        image: {
          _type: 'image',
          asset: {
            _type: 'reference',
            _ref: imageAsset?._id,
          },
        },
        admin: {
          _type: 'reference',
          _ref: user._id,
        },
      };
      client.create(doc).then((res) => {
        client
          .patch(res._id)
          .setIfMissing({ users: [] })
          .insert('after', 'users[-1]', [{
            _key: uuidv4(),
            _ref: user._id,
            _type: 'reference',
          }])
          .commit()
          .then((res) => {
            navigate('/');
          });
      });
    } else {
      setFields(true);
      setTimeout(
        () => {
          setFields(false);
        },
        2000,
      );
    }
  };

  return (
    <div className="flex flex-col justify-center items-center mt-5 lg:h-4/5">
      {fields && (
        <p className="text-red-500 mb-5 text-xl transition-all duration-150 ease-in ">Please add all fields.</p>
      )}
      <div className=" flex lg:flex-row flex-col justify-center items-center bg-white lg:p-5 p-3 lg:w-4/5  w-full">

        <div className="flex flex-1 flex-col gap-6 lg:pl-5 mt-5 w-full">
          <input
            type="text"
            value={familyName}
            onChange={(e) => setFamilyName(e.target.value)}
            placeholder="Family Name Here"
            className="outline-none text-2xl sm:text-3xl font-bold border-b-2 border-gray-200 p-2"
          />
        </div>

        <div className="bg-secondaryColor p-3 flex flex-0.7 w-full">
          <div className=" flex justify-center items-center flex-col border-2 border-dotted border-gray-300 p-3 w-full h-420">
            {loading && (
              <Spinner />
            )}
            {
              wrongImageType && (
                <p>Wrong file type.</p>
              )
            }
            {
              error && (
                <p>Sorry It Didnt Work</p>
              )
            }
            {!imageAsset ? (
              // eslint-disable-next-line jsx-a11y/label-has-associated-control
              <label>
                <div className="flex flex-col items-center justify-center h-full">
                  <div className="flex flex-col justify-center items-center">
                    <p className="font-bold text-2xl">
                      <AiOutlineCloudUpload />
                    </p>
                    <p className="text-lg">Click to upload Family Cover Photo</p>
                  </div>

                  <p className="mt-32 text-gray-400">
                    Recommendation: Use high-quality JPG, JPEG, SVG, PNG, GIF or TIFF less than 20MB
                  </p>
                </div>
                <input
                  type="file"
                  name="upload-image"
                  onChange={uploadImage}
                  className="w-0 h-0"
                />
              </label>
            ) : (
              <div className="relative h-full">
                <img
                  src={imageAsset?.url}
                  alt="uploaded-pic"
                  className="h-full w-full"
                />
                <button
                  type="button"
                  className="absolute bottom-3 right-3 p-3 rounded-full bg-white text-xl cursor-pointer outline-none hover:shadow-md transition-all duration-500 ease-in-out"
                  onClick={() => setImageAsset(null)}
                >
                  <MdDelete />
                </button>
              </div>
            )}
          </div>
        </div>
        <div className="flex flex-col">
          <div>


          </div>
          <div className="flex justify-end items-end mt-5">
            {console.log(imageAsset?._id)}
            <button
              type="button"
              onClick={savePin}
              className="bg-indigo-500 text-white font-bold p-2 rounded-full w-28 outline-none"
            >
              Save
            </button>
          </div>
        </div>

      </div>
    </div>
  );
};

export default CreateFamily;
